import { memo } from 'react';
import cx from 'clsx';
import { Checkbox } from '@kcd/design-system';

import type { OAISchema } from '~/types/openapi';

import { SafeDeliveryWithTextIcon, Text택배배송Icon } from '~/assets/icons';

import styles from './index.module.css';

type DeliveryType = OAISchema['MarketProductDetailsResponseV2']['deliveryType'];

type Props = {
  title: string;
  checked?: boolean;
  className?: string;
  deliveryType?: DeliveryType;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const CartDeliveryType = memo(
  ({ deliveryType }: { deliveryType?: DeliveryType }) => {
    if (deliveryType === 'COURIER') {
      return <Text택배배송Icon />;
    }

    if (deliveryType === 'SELF') {
      return <SafeDeliveryWithTextIcon />;
    }

    return null;
  },
);

CartDeliveryType.displayName = 'CartDeliveryType';

export const CartGroupHeader = ({
  title,
  checked,
  className,
  deliveryType,
  onChange,
}: Props) => {
  return (
    <div className={cx(styles.wrap, className)}>
      <Checkbox checked={checked} onChange={onChange}>
        <strong>{title}</strong>
      </Checkbox>

      <CartDeliveryType deliveryType={deliveryType} />
    </div>
  );
};
